import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { Overrides } from '@material-ui/core/styles/overrides';

const defaultTheme = createMuiTheme();

const overridesMyProducts: Overrides = {
  MuiInput: {
    root: {
      borderRadius: 4,
      backgroundColor: defaultTheme.palette.common.white,
      border: '1px solid #ced4da',
      fontSize: 14,
      padding: '7px 10px',
      transition: defaultTheme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
      },
      '&:before': {
        display: 'none'
      }
    }
  },

  MuiTypography: {
    title: {
      fontFamily: 'Lato',
      fontSize: 18,
      fontWeight: 'bold'
    },
    body2: {
      fontFamily: 'Lato'
    }
  },

  MuiAppBar: {
    colorPrimary: {
      backgroundColor: '#FFF !important'
    }
  },
  MuiSwitch: {
    bar: {
      borderRadius: 13,
      width: 42,
      height: 26,
      marginTop: -13,
      marginLeft: -21,
      border: 'solid 1px',
      borderColor: defaultTheme.palette.grey[400],
      backgroundColor: defaultTheme.palette.grey[50],
      opacity: 1,
      transition: defaultTheme.transitions.create(['background-color', 'border'])
    },
    icon: {
      width: 24,
      height: 24
    },
    iconChecked: {
      boxShadow: defaultTheme.shadows[1]
    },
    checked: {
      transform: 'translateX(15px)',
      '& + $bar': {
        backgroundColor: '#009358 !important',
        opacity: 1,
        border: 'none'
      }
    }
  }
};

export default overridesMyProducts;
